import React from "react";
import { TournamentEventState } from "../../types"

type Size = "xs" | "sm" | "md" | "lg" | "xl"
interface StatoBadgeProps {
  stato: TournamentEventState;
  size?: Size;
}

const badgeColors: Record<TournamentEventState, string> = {
  da_programmare: "bg-gray-200 text-gray-800",
  da_confermare: "bg-yellow-200 text-yellow-800",
  confermato: "bg-green-200 text-green-800",
  in_corso: "bg-green-400 text-green-800",
  concluso: "bg-cyan-200 text-cyan-800",
};

const statoLabels: Record<TournamentEventState, string> = {
  da_programmare: "Ancora da definire",
  da_confermare: "Da confermare",
  confermato: "Confermato",
  in_corso: "In corso",
  concluso: "Concluso",
};

const sizeClass: Record<Size, string> = {
  xs: "px-2 py-1 text-xs",
  sm: "px-3 py-1 text-sm",
  md: "px-4 py-2 text-md",
  lg: "px-4 py-2 text-lg",
  xl: "px-6 py-2 text-xl",
};

export const StateBadge: React.FC<StatoBadgeProps> = ({ stato, size = "md" }) => {
  return (
    <span
      className={`inline-block ${sizeClass[size]} rounded  ${badgeColors[stato]}`}
    >
      {statoLabels[stato]}
    </span>
  );
};
